/**
 * "Autumn in Paris" landing page — front/back flip of the product tiles and the two-click film.
 *
 * That is all this file does. Hover (on devices that can hover) is pure CSS, the buy control
 * is assets/flgntlt-lp-kauf.js, palette and story buttons are plain anchor links. The handoff's
 * other scripts (own cart, discount codes, found-secrets counter) are deliberately not ported
 * (CEO 14.10.2026).
 *
 * Flip — markup contract: [data-ap-buehne] holds both pictures and a [data-ap-wende] button; the
 * class ap-buehne--hinten shows the back. Without this script the front stays visible — the page
 * still works, only the button does nothing.
 *
 * Film — markup contract: [data-ap-film] with data-ap-film-id / -typ (youtube|vimeo) / -titel and
 * a [data-ap-film-start] button. Nothing is requested from YouTube or Vimeo before the click
 * (privacy, page weight); the click swaps the poster for the player, privacy-enhanced domains
 * only. Without this script the "watch on YouTube" link under the film still works.
 *
 * No dependencies, no build step.
 */
(function () {
  'use strict';

  if (window.__flgntltAutumnLp) return;
  window.__flgntltAutumnLp = true;

  var knoepfe = document.querySelectorAll('[data-ap-wende]');
  for (var i = 0; i < knoepfe.length; i++) {
    knoepfe[i].addEventListener('click', function (e) {
      e.preventDefault();
      var buehne = this.closest('[data-ap-buehne]');
      if (!buehne) {
        console.error('Autumn-LP: Wendeknopf ohne Bühne', this);
        return;
      }
      var hinten = buehne.classList.toggle('ap-buehne--hinten');
      this.setAttribute('aria-pressed', String(hinten));
    });
  }

  /** Player URL for a video id — null for anything we do not know how to embed. */
  function playerUrl(typ, id) {
    if (!/^[A-Za-z0-9_-]+$/.test(id || '')) return null;
    if (typ === 'youtube') {
      return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    }
    if (typ === 'vimeo') {
      return 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
    }
    return null;
  }

  var filme = document.querySelectorAll('[data-ap-film]');
  for (var f = 0; f < filme.length; f++) {
    (function (rahmen) {
      var start = rahmen.querySelector('[data-ap-film-start]');
      if (!start) return;
      start.addEventListener('click', function (e) {
        e.preventDefault();
        var url = playerUrl(rahmen.getAttribute('data-ap-film-typ'), rahmen.getAttribute('data-ap-film-id'));
        if (!url) {
          console.error('Autumn-LP: Film ohne gültige Video-ID', rahmen.getAttribute('data-ap-film-typ'), rahmen.getAttribute('data-ap-film-id'));
          return;
        }
        var player = document.createElement('iframe');
        player.src = url;
        player.title = rahmen.getAttribute('data-ap-film-titel') || 'Film';
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.setAttribute('allowfullscreen', '');
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        rahmen.innerHTML = '';
        rahmen.appendChild(player);
        rahmen.classList.add('ap-film__rahmen--laeuft');
        player.focus();
      });
    })(filme[f]);
  }
})();
